import { Component, EventEmitter, Input, Optional, Output, OnDestroy, ViewChild, HostListener, } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AuthService, CurrencyChangerService, DataStoreService, EnvironmentConfig, EVENTS, EventService, IAdmin, IUser, ListingService, PaymentService, TrackingService, CorporateAccountService, NotificationService } from '@clooper/core';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { faArrowLeft, faBars, faBell, faChevronDown, faSearch, faSignOut, faTimes, faLocation, faHotel } from '@fortawesome/pro-light-svg-icons';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import * as moment from 'moment';
import { PropertyTypeWelcomeModalComponent } from '../../modals/property-type-welcome-modal/property-type-welcome-modal.component';
import { RestrictionModalComponent } from '../restriction-modal/restriction-modal.component';
import { ExtraServiceModalComponent } from '../../modals/extra-service-modal/extra-service-modal.component';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

type NotificationItem = {
  id: string;
  title: string;
  message: string;
  createdAt: string | Date;
  read: boolean;
  avatar?: string;
  initials?: string;
  color?: string;
  type?: 'booking' | 'approval' | 'credit' | 'cancel' | string;
  link?: string;
};
@Component({
  selector: 'app-dashboard-page-header',
  templateUrl: './dashboard-page-header.component.html',
  styleUrls: ['./dashboard-page-header.component.scss']
})
export class DashboardPageHeaderComponent implements OnDestroy {
  icons: any = {
    bell: faBell,
    chevron: faChevronDown,
    chevronDown: faChevronDown,
    menu: faBars,
    close: faTimes,
    signout: faSignOut,
    add: faPlus,
    back: faArrowLeft,
    search: faSearch,
    hotel: faHotel,
    location: faLocation
  }
  bsModalRef?: BsModalRef;
  activeTab: string = '';

  showNotifications = false;
  notifTab: 'all' | 'unread' = 'all';
  notifications: NotificationItem[] = [];
  pageSize = 50;
  pageNumber = 1;
  hasMore = false;

  @Input() isOpened = false;

  @Input() user: IUser;
  get isAdmin(): boolean {
    return this.user?.business?.role === 'admin';
  }
  @Input() admin: IAdmin;
  @Input() menuItems: any = [];
  @Input() subItems: any = [];
  @Input() disableToggle: boolean;
  @Input() showCurrencyDropdown: boolean = false;
  @Input() viewType = 'user'
  @Output() toggled = new EventEmitter<boolean>();
  @Input() isCreate = false
  @Output() onToggleMenu = new EventEmitter<boolean>();

  searchSubject = new Subject<string>();


  webappURL: string | undefined;
  searchValue: string;

  //
  currentUrl: string = "/listings";

  routerSubs: Subscription

  showMobileSearch: boolean
  searchBarFlag: boolean;
  currencies: any;
  @Input() selectedCurrency: string = "GBP";

  filterParams: any = {};
  showCurrency: any;

  @Input() backUrl: string = '/properties'

  @ViewChild('dropdownToggle') dropdown: any;


  constructor(
    private router: Router,
    config: EnvironmentConfig,
    private tracker: TrackingService,
    private modalService: BsModalService,
    public listingService: ListingService,
    private payment: PaymentService,
    @Optional() private eventSrv: EventService,
    @Optional() private authService: AuthService,
    private route: ActivatedRoute,
    private headerService: CurrencyChangerService,
    private storage: DataStoreService,
    private notificationService: NotificationService,
    private corporateAccountService: CorporateAccountService
  ) {
    this.webappURL = config.webappUrl

    this.routerSubs = this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationEnd) {
          this.currentUrl = event.url
          console.log(event.url)
          this.showCurrencyDropdown = this.shouldShowDropdown(event.url)
        }
      }
    )
    this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length !== 0) {
        this.filterParams = params;
      }
    });

  }

  ngOnInit() {
    this.fetchNotifications();
    this.user = this.authService.getAuthorizedUser()
    if (this.user?._id || this.user?.id) {
      this.initNotificationSocket(this.user._id || this.user.id);
    }
    this.eventSrv.observeUser.subscribe(user => {
      if (user) {
        this.user = user
        this.fetchPreference()
        if (this.user?._id || this.user?.id) {
          this.initNotificationSocket(this.user._id || this.user.id);
        }
      }
    })
    this.hideToggle(this.router.url)
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: any) => {
        this.hideToggle(event.url)
        this.isOpened = false;
        this.toggled.emit(this.isOpened);
      })
    this.getCurrencies()
    this.fetchPreference()
    // this.searchSubject
    // .pipe(
    //   debounceTime(1000),
    //   distinctUntilChanged()
    // )
    // .subscribe((value: any) => {
    //   this.searchLocation(value);
    // });
    // const data = this.headerService.getSelectedCurrency()
  }

  // onSearchChange(value: string) {
  //   this.searchSubject.next(value);
  // }

  fetchPreference() {
    if (this.user?.business?._id) {
      this.corporateAccountService.getPreference(this.user.business._id).subscribe((res: any) => {
        if (res?.data?.default_currency) {
          this.selectedCurrency = res.data.default_currency;
              this.headerService.setCurrencyChange({ changeCurrency: true, reloaded: true, currency: res.data.default_currency })

        }
      });
    }
  }

  shouldShowDropdown(url: string): boolean {
    const [path, query] = url.split('?');
    if (path === '/flights') {
      return !!query;
    }

    // listings dropdown only when query params exist
    if (path === '/listings') {
      return !!query;
    }

    const patterns = [
      /^\/listings\/[^/]+$/,
      /^\/listings\/hotel-apartment\/[^/]+$/,
      /^\/listings\/hotel-apartments\/[^/]+$/,
    ];
    return patterns.some((pattern) => pattern.test(path));
  }


  ngOnDestroy(): void {
    this.routerSubs.unsubscribe()
    this.notificationService.disconnectSocket();
  }

  initNotificationSocket(userId: string) {
    this.fetchUnreadCount();
    this.notificationService.initSocket(userId);
    this.notificationService.newNotification$.subscribe((data) => {
      this.fetchNotifications();
      this.fetchUnreadCount();
    });
  }

  unreadCount: number = 0;

  fetchUnreadCount() {
    this.notificationService.getUnreadCount().subscribe((res: any) => {
      this.unreadCount = res?.data?.count || res?.count || 0;
    });
  }

  get filteredNotifications(): NotificationItem[] {
    return this.notifTab === 'unread'
      ? this.notifications.filter(n => !n.read)
      : this.notifications;
  }
  trackById(_: number, n: NotificationItem) { return n.id; }

  toggleNotifications() {
    this.showNotifications = !this.showNotifications;
    if (this.showNotifications && this.notifications.length === 0) {
      this.fetchNotifications();
    }
  }

  @HostListener('document:click')
  closePanelsOnOutsideClick() {
    this.showNotifications = false;
  }

  setTab(tab: 'all' | 'unread') {
    this.notifTab = tab;
    this.fetchNotifications(false);
  }

  fetchNotifications(loadMore = false) {
    if (loadMore) {
      this.pageNumber++;
    } else {
      this.pageNumber = 1;
    }

    const isReadParam = this.notifTab === 'unread' ? false : undefined;

    this.notificationService
      .getNotifications(this.pageNumber, this.pageSize, isReadParam)
      .subscribe((res: any) => {
        // Backend returns: { data: { notifications: [...] } }
        // The fetch method in resource.ts extracts resp.data['notifications'] returning the array
        // But if it doesn't, we handle both scenarios safely:
        const rawItems = Array.isArray(res) ? res : (res?.notifications || res?.data?.notifications || res?.data || []);

        const items: NotificationItem[] = (Array.isArray(rawItems) ? rawItems : []).map(this.toUiNotification);
        this.notifications = loadMore ? [...this.notifications, ...items] : items;
        this.hasMore = items.length === this.pageSize;
      });
  }
  getDays(date: string | Date): string {
    return moment(date).fromNow();
  }
  loadMore() {
    if (this.hasMore) this.fetchNotifications(true);
  }

  markAllAsRead() {
    const ids = this.notifications.filter(n => !n.read).map(n => n.id);
    if (!ids.length) return;
    this.notificationService.markAllAsRead().subscribe(() => {
      this.notifications = this.notifications.map(n => ({ ...n, read: true }));
      this.unreadCount = 0;
    });
  }

  openNotification(n: NotificationItem) {
    if (!n.read) {
      this.notificationService.markAsRead(n.id).subscribe(() => {
        n.read = true;
        this.unreadCount = Math.max(0, this.unreadCount - 1);
      });
    }
    if (n.link) this.router.navigateByUrl(n.link);
  }

  /** Mapping helpers */
  private toUiNotification = (raw: any): NotificationItem => {
    const name = raw.actor_name || raw.title || 'Clooper';
    return {
      id: raw.id,
      title: name,
      message: this.renderMessage(raw),
      createdAt: raw.created_at || raw.createdAt,
      read: raw.isRead !== undefined ? !!raw.isRead : !!raw.read,
      avatar: raw.actor_avatar || undefined,
      initials: this.makeInitials(name),
      color: this.colorFromSeed(name),
      type: raw.type,
      link: this.linkFromType(raw),
    };
  };

  private renderMessage(raw: any): string {
    if (raw.message) return raw.message;
    switch (raw.type) {
      case 'booking.created':
      case 'BOOKING_CREATED':
        return ' just made a booking';
      case 'approval.requested':
      case 'APPROVAL_REQUESTED':
        return ' just requested approval';
      case 'credit.added':
      case 'CREDIT_ADDED':
        return ' you just received credit';
      case 'booking.cancel_request':
      case 'BOOKING_CANCEL_REQUEST':
        return ' just sent a booking cancel request';
      default: return '';
    }
  }

  private linkFromType(raw: any): string | undefined {
    switch (raw.type) {
      case 'booking.created':
      case 'BOOKING_CREATED':
        return `/my-bookings/${raw.metadata?.bookingId || raw.booking_id}`;
      case 'approval.requested':
      case 'APPROVAL_REQUESTED':
        return `/corporate-account/approvals`;
      case 'booking.cancel_request':
      case 'BOOKING_CANCEL_REQUEST':
        return `/my-bookings/${raw.metadata?.bookingId || raw.booking_id}`;
      default: return undefined;
    }
  }

  private makeInitials(name: string): string {
    if (!name) return 'CL';
    const p = name.trim().split(/\s+/);
    return ((p[0]?.[0] || '') + (p[1]?.[0] || '')).toUpperCase();
  }
  private colorFromSeed(seed: string): string {
    let h = 0; for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) % 360;
    return `hsl(${h}, 45%, 75%)`;
  }

  toggle() {
    this.isOpened = !this.isOpened;
    this.toggled.emit(this.isOpened);
  }

  hideToggle(url: string) {
    if (url.includes('properties/create')) {
      this.disableToggle = true;
    } else {
      this.disableToggle = false;
    }
  }

  logout() {
    this.authService.signout()
    this.router.navigate(['/login'])
  }


  gotoPreference(user: any) {
    if (user.matching_locations?.length === 0) {
      this.router.navigateByUrl('/tenant-profile/create/start')
    }
  }

  getCurrencies() {
    this.payment.getCurrencies().subscribe((res: any) => {
      this.currencies = res.data
    })
  }

  swapCurrency(currency: string, event: any) {
    event.stopPropagation()
    this.headerService.setCurrencyChange({ changeCurrency: true, reloaded: true, currency })
    this.storage.save("currency", currency)
    this.headerService.headerUpdate$
      .subscribe(payload => {
        if (payload.currency) {
          this.selectedCurrency = payload.currency;
        }
      });
    this.dropdown.nativeElement.click()
  }

  listYourProperty() {
    this.modalService.show(PropertyTypeWelcomeModalComponent, { class: 'modal-rounded' })
    this.tracker.track(EVENTS.CREATE_PROPERTY, this.router.url)
  }

  showMenu() {
    this.onToggleMenu.emit(true);
  }
  showSearchBar() {
    this.searchBarFlag = true
  }
  closeSearchBar() {
    this.searchBarFlag = false
  }

  checkForRestriction(event: any) {
    console.log(event)
    if (event.changeToEnquiry === true) {
      const options: any = { class: 'modal-rounded' }
      this.bsModalRef = this.modalService.show(RestrictionModalComponent, options)

    }
  }

  gotoAction(item: any) {
    if (item.name === 'Find a property') {
      this.searchBarFlag = true
    } else if (item.name === 'Extra Services') {
      const initialState = { user: this.user, booking: null, }
      const options: any = { initialState, class: 'modal-rounded' }
      this.bsModalRef = this.modalService.show(ExtraServiceModalComponent, options)

    } else {

      this.router.navigateByUrl(item.url)
    }
  }


  //    airlineSearch = '';
  //   showLocationDropdown = false;
  //   selectedLocation: any;
  //   selectedAirline: any;
  //   filteredLocations: any
  // locationLoading: boolean  = false
  //   toggleLocationDropdown(): void {
  //     this.showLocationDropdown = !this.showLocationDropdown;
  //     if (this.showLocationDropdown) {
  //       this.airlineSearch = '';
  //       // this.filteredLocations = this.airlines;
  //     }
  //   }

  //   searchLocation(term: string): void {
  //     // const term = this.airlineSearch.toLowerCase();
  //     console.log(term)
  //     const payload = {
  //       query: term
  //     }

  //     this.locationLoading = true;
  //     this.listingService.fetchListingViaAutocomplete(payload).subscribe((resp: any) => {
  //       console.log(resp)
  //       this.filteredLocations = resp.data;
  //       this.locationLoading = false;
  //           this.showLocationDropdown = true;
  //     })

  //   }


  //    selectLocation(data: any): void {
  //       this.selectedLocation = data;
  //       console.log(data)
  //       this.airlineSearch = data?.region_id && data?.hid
  //       ? data?.name
  //     : `${data?.name}, ${data?.country_name}`
  //       this.showLocationDropdown = false;
  //     }


  //     clear() {
  //       this.toggleLocationDropdown()
  //       this.selectedLocation = {}
  //     }
}

